import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import About from "./pages/Aboutus";
import Services from './pages/services';
import OurTeam from "./pages/OurTeam";
import Footer from "./components/Footer";
import SuccessStories from "./pages/SuccessStories";
import Contact from "./pages/contact";
import ScrollToTop from './components/ScrollToTop';
import Whyrts from "./pages/whyrts";
import "./App.css"

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} /> 
          <Route path="/services" element={<Services />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/ourTeam" element={<OurTeam />} />
          <Route path="/successStories" element={<SuccessStories />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/whyrts" element={<Whyrts />} />
         


         
        </Routes>
        
        <Footer /> {/* Global footer */}
      </div>
    </Router>
  );
}

export default App;
